import { useEffect, useState } from 'react';

export const useLocalStorage = () => {
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const storedAuthUser = JSON.parse(localStorage.getItem('authUser'));
    setAuthUser(storedAuthUser);
  }, []);

  const getAuthUserID = () => {
    return authUser ? authUser.id : null;
  };
  const getAuthUserName = () => {
    return authUser ? authUser.name : null;
  };
  

  return { getAuthUserID, getAuthUserName };
};
